import React, { useEffect, useRef, useState, lazy, Suspense } from 'react';

//components

// import Breakingnews from './Breakingnews';
// import Politicsnews from './Politicsnews';
// import Cardslider from './Cardslider';
// import Luxuryproducts from './Luxuryproducts';
// import Sportnews from './Sportnews';
// import MonthStorySlider from './MonthStorySlider';
// import Topstoryslider from './Topstoryslider';
// import Marketnews from './Marketnews';
import Coverstories from './Coverstories';
// import Livenews from './Livenews';
const Fashion = lazy(() => import('./Fashion'));
const Health = lazy(() => import('./Health'));
const Sports = lazy(() => import('./Sports'));
const Technology = lazy(() => import('./Technology'));
const Business = lazy(() => import('./Business'));
const Politics = lazy(() => import('./Politics'));
const Entertainment = lazy(() => import('./Entertainment'));
const Article = lazy(() => import('./Article'));


const LazyLoadSection = ({ Component }) => {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.disconnect();
                }
            },
            { rootMargin: '0px 0px 120px 0px', threshold: 0 }
        );
        if (ref.current) observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);
    return (
        <div ref={ref} style={{ minHeight: visible ? 'auto' : '400px' }}>
            {visible ? (
                <Suspense fallback={null}>
                    <Component enabled />
                </Suspense>
            ) : null}
        </div>
    );
};

const Home = () => {

    return (
        <>
            <div className="sr-only">
                <h1>Top UK News and International News Updates with Across Nations at Forbes</h1>
                <h2>Top UK news and international news updates with across nations news at Forbes, providing reliable, accurate, and timely information for readers around the world. Powered by a professional development company by <a href="https://pmcommu.com">pmcommu.com</a>
                </h2>
            </div>
            {/* <Commoninformation /> */}
            {/* <Breakingnews /> */}
            <Coverstories />
            {/* <Livenews /> */}
            {/* <Politicsnews /> */}
            <LazyLoadSection Component={Fashion} />
            <LazyLoadSection Component={Business} />
            <LazyLoadSection Component={Sports} />
            <LazyLoadSection Component={Technology} />
            <LazyLoadSection Component={Health} />
            <LazyLoadSection Component={Politics} />
            <LazyLoadSection Component={Entertainment} />
            <LazyLoadSection Component={Article} />

            {/* <Cardslider /> */}
            {/* <Luxuryproducts />
            <Sportnews /> */}
            {/* <MonthStorySlider />
            <Topstoryslider />
            <Marketnews /> */}

        </>
    )
}

export default Home
